import React, { useContext } from "react";
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from "@mui/material";
import GroupBDRBiologists from "../FieldTags/GroupBDRBiologists";
import { UserContext } from "../../context/UserContext";
import xplanLabels from "../../util/XplanLabels";
import ROLES from "../../util/roles";
import HistoryLogElement from "./HistoryLogElement";
import { checkRole } from "../../util/FormUtils";

const newPlan = window.location.pathname === "/xplans/new";

const ApprovedSOP = ({ approvedSOP, handleChange, xplans, required }) => {
    const { user } = useContext(UserContext);
    const canEdit = checkRole(user, [ROLES.BIOLOGIST, ROLES.APPROVER]);

    return (
        <div id="approvedSOP" className="planField">
            <GroupBDRBiologists />
            <FormControl required={required.includes("approvedSOP")}>
                <FormLabel className="planRadioTitle">
                    {xplanLabels.approvedSOP}
                </FormLabel>
                <RadioGroup
                    name="approvedSOP"
                    label={xplanLabels.approvedSOP}
                    value={approvedSOP}
                    onChange={(e) => handleChange("approvedSOP", e.target.value)}
                    row
                >
                    <FormControlLabel
                        value="Yes"
                        control={<Radio disabled={!canEdit} />}
                        label="Yes"
                    />
                    <FormControlLabel
                        value="No"
                        control={<Radio disabled={!canEdit} />}
                        label="No"
                    />
                    <FormControlLabel
                        value="Requested"
                        control={<Radio disabled={!canEdit} />}
                        label="Requested"
                    />
                </RadioGroup>
            </FormControl>
            {!newPlan && <HistoryLogElement xplans={xplans} label={"approvedSOP"} />}
        </div>
    );
};

export default ApprovedSOP;